import React from 'react';
import { MetricsElement } from 'react-metrics';


export default React.memo(React.forwardRef((
	{
		element,
		onClick,
		tabIndex = 0,
		className = "",
		children,
		metricsData = null,
		ariaLabel,
		style,
		onKeyUp = (e) => {
			let charCode = e.keyCode || e.which;
			if (charCode === 13) {
				if (onClick) {
					onClick(e)
				} else {
					//trigger element click if no click handler provided
					try {
						e.currentTarget.click()
					} catch (e) { }
				}
			}
		},
		...otherProps
	}, ref) => {
	let props = {
		onKeyUp,
		onClick,
		tabIndex,
		className,
		style,
		ref,
		'aria-label': ariaLabel,
		...otherProps
	}

	if (metricsData) {
		return (
			<MetricsElement element={element} {...props} {...metricsData}>
				{children ? children : null}
			</MetricsElement>
		)
	} else {
		return (
			React.createElement(element, props, children)
		)
	}
}));